export const ErrorMap: Record<string, string> = {
  AGENCY_IS_DISABLED: "Đại lý chưa được kích hoạt",
  INVALID_PASSWORD: "Mật khẩu không chính xác",
  PASSWORD_MUST_NOT_BE_THE_OLD_PASSWORD: "Mật khẩu mới không được đặt trùng mật khẩu cũ",
  USER_IS_DISABLED: "Tài khoản đã bị khoá",
}
